import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pinIdAdapter27yg3a7qzsov7 as get_pinIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePinInputnc3r3ek8pldn as SavePinInput } from '../SavePinInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePinInput_InputAdapterClass;
function SavePinInput_InputAdapter() {
  if (SavePinInput_InputAdapterClass === VOID) {
    class $ {
      s41(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      j75(writer, customScalarAdapters, value) {
        writer.k4e('partyId');
        get_partyIdAdapter().t41(writer, customScalarAdapters, value.u73_1);
        writer.k4e('pinId');
        get_pinIdAdapter().t41(writer, customScalarAdapters, value.v73_1);
        writer.k4e('icon');
        get_StringAdapter().t41(writer, customScalarAdapters, value.w73_1);
        writer.k4e('name');
        get_StringAdapter().t41(writer, customScalarAdapters, value.x73_1);
      }
      t41(writer, customScalarAdapters, value) {
        return this.j75(writer, customScalarAdapters, value instanceof SavePinInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePinInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePinInput_InputAdapterClass = $;
  }
  return SavePinInput_InputAdapterClass;
}
var SavePinInput_InputAdapter_instance;
function SavePinInput_InputAdapter_getInstance() {
  return SavePinInput_InputAdapter_instance;
}
//region block: init
SavePinInput_InputAdapter_instance = new (SavePinInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePinInput_InputAdapter_instance as SavePinInput_InputAdapter_instance206p67199oefc,
};
//endregion

//# sourceMappingURL=SavePinInput_InputAdapter.mjs.map
